var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-6 col-xs-offset-3 col-md-2 col-md-offset-5  form-group"},[_c('div',{staticClass:"share_btn share_btn_peachDefault"},[_c('a',{on:{"click":_vm.update}},[_vm._v("立即啟動 Go")])])])}
var staticRenderFns = []

export { render, staticRenderFns }